import { Flex, Image } from "@chakra-ui/react";
import { useRecoilValue } from "recoil";

import usePriceLocalization from "components/hooks/Localization/usePriceLocalization";
import useProductLocalization from "components/hooks/Localization/useProductLocalization";
import { OFText } from "design_system/components/OFText";
import { StripePriceLocaleKeys, StripeProductLocaleKeys } from "graphql/generated";
import { platformState } from "src/states";
import { getImageUrlFromImageModel } from "src/utils";

import { PRODUCT_NAME_STYLE } from "./constant/style";

type Props = {
  item: any;
  displayFrequency?: string;
};

export const summaryItemImageProps = {
  h: { base: "60px", md: "60px" },
  w: { base: "60px", md: "60px" }
};

export const OrderSummaryItemHeader = ({ item, displayFrequency }: Props) => {
  const { getTranslatedText } = useProductLocalization();
  const { getTranslatedTextForPrice } = usePriceLocalization();
  const { price, product, quantity } = item;

  const platform = useRecoilValue(platformState);

  const { image, id } = product;
  const translatedTexts = getTranslatedTextForPrice(price?.id);

  const frequencyQuantity = translatedTexts?.[StripePriceLocaleKeys.FrequencyQuantityDisplay];

  const displayFrequencyField = displayFrequency || StripePriceLocaleKeys.PriceFrequency;

  return (
    <Flex mb="16px">
      <Image
        {...summaryItemImageProps}
        src={getImageUrlFromImageModel(image, platform, true)}
        borderRadius="8px"
        objectFit="cover"
      />
      <Flex justifyContent="space-between" flex={1}>
        <Flex ml={["16px"]} flexDirection="column" gap="8px">
          <OFText textStyle={PRODUCT_NAME_STYLE}>
            {`${getTranslatedText(id, StripeProductLocaleKeys.ProductName)}${
              quantity > 1 ? ` x${quantity}` : ""
            }`}
          </OFText>
          <Flex flexDirection="column">
            {frequencyQuantity && <OFText textStyle="body3">{frequencyQuantity}</OFText>}
            <OFText textStyle="body3">{translatedTexts?.[displayFrequencyField]}</OFText>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
